import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Le service worker vit dans public/service-worker.js : il rend l'application
// installable, sert les assets hachés depuis le cache et garde un index.html de
// secours pour les coupures réseau. Les navigations restent en réseau d'abord,
// pour ne jamais servir un index.html périmé après un déploiement.
serviceWorkerRegistration.register();
